/**
 * Created by neng on 23/10/2559.
 */
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'thaidatetime',
  standalone: true
})

export class ThaiDateTimePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      if ((typeof value) === 'string') {
        let compact = value.trim();
        if (/^\d{8}$/.test(compact)) {
          value = new Date(Number(compact.slice(0, 4)), Number(compact.slice(4, 6)) - 1, Number(compact.slice(6, 8)));
        } else if (/^\d{14}$/.test(compact)) {
          value = new Date(Number(compact.slice(0, 4)), Number(compact.slice(4, 6)) - 1, Number(compact.slice(6, 8)), Number(compact.slice(8, 10)), Number(compact.slice(10, 12)), Number(compact.slice(12, 14)));
        } else {
          let part = value.split(/[^0-9]/);
          if (part.length == 6) {
            value = new Date(Number(part[0]), Number(part[1]) - 1, Number(part[2]), Number(part[3]), Number(part[4]), Number(part[5]));
          } else if (part.length == 7) {
            // Java LocalDateTime carries a 6-9 digit fraction; JS Date wants milliseconds.
            const millis = Number(part[6].substring(0, 3).padEnd(3, '0'));
            value = new Date(Number(part[0]), Number(part[1]) - 1, Number(part[2]), Number(part[3]), Number(part[4]), Number(part[5]), millis);
          } else {
            value = new Date(Number(part[0]), Number(part[1]) - 1, Number(part[2]));
          }
        }
      }
      let defaultOption = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        showTime: true,
        full: false
      };
      let options = {...defaultOption, ...args};
      if (!!options.showTime) {
        let options = {...defaultOption, ...args};
        let dateFormat = {year: options.year, month: options.month, day: options.day};
        let timeFormat = {hour: options.hour, minute: options.minute};
        let date: string = value.toLocaleDateString("th-TH", dateFormat);
        let time: string = value.toLocaleTimeString("th-TH", timeFormat);
        return options.full ? date + " เวลา " + time + " น." : date + " " + time + " น.";
      } else {
        let options = {...defaultOption, ...args};
        let dateFormat = {year: options.year, month: options.month, day: options.day};
        return value.toLocaleDateString("th-TH", dateFormat);
      }
    } else {
      return "";
    }

  }
}

